<template>
    <v-flex fill-height>
        <sidemainmenu/>
        <br />
        <v-container fluid grid-list-md>
            <v-toolbar color="grey lighten-4" dense>
              <v-btn flat color="blue darken-4">{{ analytics_list.today.date_analytics }}</v-btn>
            </v-toolbar>
            <v-layout row wrap>
                <v-flex d-flex xs12 sm12 md3>
                <v-card color="white" class="black--text">
                    <v-card-title class="title">
                        <v-icon large color="indigo darken-2">line_weight</v-icon>&nbsp;&nbsp;&nbsp;&nbsp;
                        <div>
                            <div class="headline">{{ analytics_list.today.cfs_igm_pending }}</div>
                            <div><hr /></div>
                        </div>
                    </v-card-title>
                    <v-card-actions>
                      <v-btn flat color="indigo" v-on:click="igmpending()">Arrival List</v-btn>
                    </v-card-actions>
                </v-card>
              </v-flex>
              <v-flex d-flex xs12 sm12 md3>
                <v-card color="white" class="black--text">
                    <v-card-title class="title">
                        <v-icon large color="red darken-2">trending_flat</v-icon>&nbsp;&nbsp;&nbsp;&nbsp;
                        <div>
                            <div class="headline">{{ analytics_list.today.cfs_arrival_pending }}</div>
                            <div><hr /></div>
                        </div>
                    </v-card-title>
                    <v-card-actions>
                      <v-btn flat color="red" v-on:click="gateinpending()">Gate In Pending</v-btn>
                    </v-card-actions>
                </v-card>
              </v-flex>
              <v-flex d-flex xs12 sm12 md3>
                <v-card color="white" class="black--text">
                    <v-card-title class="title">
                        <v-icon large color="purple darken-2">input</v-icon>&nbsp;&nbsp;&nbsp;&nbsp;
                        <div>
                            <div class="headline">{{ today_gin_total }}({{ analytics_list.today.gate_in_20}}/{{ analytics_list.today.gate_in_40}})</div>
                            <div><hr /></div>
                        </div>
                    </v-card-title>
                    <v-card-actions>
                      <v-btn flat color="purple" v-on:click="gateins()">Gate In</v-btn>
                    </v-card-actions>
                </v-card>
              </v-flex>
              <v-flex d-flex xs12 sm12 md3>
                <v-card color="white" class="black--text">
                    <v-card-title class="title">
                        <v-icon large color="blue darken-2">view_list</v-icon>&nbsp;&nbsp;&nbsp;&nbsp;
                        <div>
                            <div class="headline">{{ analytics_list.today.stock_loaded }}</div>
                            <div><hr /></div>
                        </div>
                    </v-card-title>
                    <v-card-actions>
                      <v-btn flat color="blue" v-on:click="loadedstock()">Loaded Stock</v-btn>
                    </v-card-actions>
                </v-card>
              </v-flex>
              <br />
              <v-flex d-flex xs12 sm12 md3>
                <v-card color="white" class="black--text">
                    <v-card-title class="title">
                        <v-icon large color="cyan darken-2">aspect_ratio</v-icon>&nbsp;&nbsp;&nbsp;&nbsp;
                        <div>
                            <div class="headline">{{ analytics_list.today.stock_empty }}</div>
                            <div><hr /></div>
                        </div>
                    </v-card-title>
                    <v-card-actions>
                      <v-btn flat color="cyan darken-2">Empty Stock</v-btn>
                    </v-card-actions>
                </v-card>
              </v-flex>
              <v-flex d-flex xs12 sm12 md3>
                <v-card color="white" class="black--text">
                    <v-card-title class="title">
                        <v-icon large color="orange darken-2">list_alt</v-icon>&nbsp;&nbsp;&nbsp;&nbsp;
                        <div>
                            <div class="headline">{{ analytics_list.today.fcl }}</div>
                            <div><hr /></div>
                        </div>
                    </v-card-title>
                    <v-card-actions>
                      <v-btn flat color="orange" v-on:click="fclgateout()">FCL Gate Out</v-btn>
                    </v-card-actions>
                </v-card>
              </v-flex>
              <v-flex d-flex xs12 sm12 md3>
                <v-card color="white" class="black--text">
                    <v-card-title class="title">
                        <v-icon large color="red darken-2">apps</v-icon>&nbsp;&nbsp;&nbsp;&nbsp;
                        <div>
                            <div class="headline">{{ analytics_list.today.destuff}}</div>
                            <div><hr /></div>
                        </div>
                    </v-card-title>
                    <v-card-actions>
                      <v-btn flat color="red" v-on:click="destuffcargo()">De-Stuff Gate Out</v-btn>
                    </v-card-actions>
                </v-card>
              </v-flex>
              <v-flex d-flex xs12 sm12 md3>
                <v-card color="white" class="black--text">
                    <v-card-title class="title">
                        <v-icon large color="orange darken-2">video_label</v-icon>&nbsp;&nbsp;&nbsp;&nbsp;
                        <div>
                            <div class="headline">{{ analytics_list.today.ec_gout}}</div>
                            <div><hr /></div>
                        </div>
                    </v-card-title>
                    <v-card-actions>
                      <v-btn flat color="orange" v-on:click="ecgateout()">Empty Container G/Out</v-btn>
                    </v-card-actions>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
          <!-- Yesterday Analytics -->
          <v-container fluid grid-list-md>
            <v-toolbar color="grey lighten-4" dense>
                <v-btn flat color="blue darken-4">{{ analytics_list.yesterday.date_analytics }}</v-btn>
            </v-toolbar>
            <v-layout row wrap>
              <v-flex d-flex xs12 sm12 md3>
                <v-card color="white" class="black--text">
                    <v-card-title class="title">
                        <v-icon large color="purple darken-2">input</v-icon>&nbsp;&nbsp;&nbsp;&nbsp;
                        <div>
                            <div class="headline">{{ yesterday_gin_total }} ({{ analytics_list.yesterday.gate_in_20}}/{{ analytics_list.yesterday.gate_in_40}})</div>
                            <div><hr /></div>
                        </div>
                    </v-card-title>
                    <v-card-actions>
                      <v-btn flat color="purple">Gate In</v-btn>
                    </v-card-actions>
                </v-card>
              </v-flex>
              <v-flex d-flex xs12 sm12 md3>
                <v-card color="white" class="black--text">
                    <v-card-title class="title">
                        <v-icon large color="orange darken-2">list_alt</v-icon>&nbsp;&nbsp;&nbsp;&nbsp;
                        <div>
                            <div class="headline">{{ analytics_list.yesterday.fcl }}</div>
                            <div><hr /></div>
                        </div>
                    </v-card-title>
                    <v-card-actions>
                      <v-btn flat color="orange">FCL Gate Out</v-btn>
                    </v-card-actions>
                </v-card>
              </v-flex>
              <v-flex d-flex xs12 sm12 md3>
                <v-card color="white" class="black--text">
                    <v-card-title class="title">
                        <v-icon large color="red darken-2">apps</v-icon>&nbsp;&nbsp;&nbsp;&nbsp;
                        <div>
                            <div class="headline">{{ analytics_list.yesterday.destuff}}</div>
                            <div><hr /></div>
                        </div>
                    </v-card-title>
                    <v-card-actions>
                      <v-btn flat color="red">De-Stuff Gate Out</v-btn>
                    </v-card-actions>
                </v-card>
              </v-flex>
              <v-flex d-flex xs12 sm12 md3>
                <v-card color="white" class="black--text">
                    <v-card-title class="title">
                        <v-icon large color="orange darken-2">video_label</v-icon>&nbsp;&nbsp;&nbsp;&nbsp;
                        <div>
                            <div class="headline">{{ analytics_list.yesterday.ec_gout}}</div>
                            <div><hr /></div>
                        </div>
                    </v-card-title>
                    <v-card-actions>
                      <v-btn flat color="orange">Empty Container G/Out</v-btn>
                    </v-card-actions>
                </v-card>
              </v-flex>
            </v-layout>
        </v-container>
        <!-- Day Before Yesterday Analytics -->
          <v-container fluid grid-list-md>
            <v-toolbar color="grey lighten-4" dense>
                <v-btn flat color="blue darken-4">{{ analytics_list.day4uyesterday.date_analytics }}</v-btn>
            </v-toolbar>
            <v-layout row wrap>
              <v-flex d-flex xs12 sm12 md3>
                <v-card color="white" class="black--text">
                    <v-card-title class="title">
                        <v-icon large color="purple darken-2">input</v-icon>&nbsp;&nbsp;&nbsp;&nbsp;
                        <div>
                            <div class="headline">{{ day4uyesterday_gin_total }} ({{ analytics_list.day4uyesterday.gate_in_20}}/{{ analytics_list.day4uyesterday.gate_in_40}})</div>
                            <div><hr /></div>
                        </div>
                    </v-card-title>
                    <v-card-actions>
                      <v-btn flat color="purple">Gate In</v-btn>
                    </v-card-actions>
                </v-card>
              </v-flex>
              <v-flex d-flex xs12 sm12 md3>
                <v-card color="white" class="black--text">
                    <v-card-title class="title">
                        <v-icon large color="orange darken-2">list_alt</v-icon>&nbsp;&nbsp;&nbsp;&nbsp;
                        <div>
                            <div class="headline">{{ analytics_list.day4uyesterday.fcl }}</div>
                            <div><hr /></div>
                        </div>
                    </v-card-title>
                    <v-card-actions>
                      <v-btn flat color="orange">FCL Gate Out</v-btn>
                    </v-card-actions>
                </v-card>
              </v-flex>
              <v-flex d-flex xs12 sm12 md3>
                <v-card color="white" class="black--text">
                    <v-card-title class="title">
                        <v-icon large color="red darken-2">apps</v-icon>&nbsp;&nbsp;&nbsp;&nbsp;
                        <div>
                            <div class="headline">{{ analytics_list.day4uyesterday.destuff}}</div>
                            <div><hr /></div>
                        </div>
                    </v-card-title>
                    <v-card-actions>
                      <v-btn flat color="red">De-Stuff Gate Out</v-btn>
                    </v-card-actions>
                </v-card>
              </v-flex>
              <v-flex d-flex xs12 sm12 md3>
                <v-card color="white" class="black--text">
                    <v-card-title class="title">
                        <v-icon large color="orange darken-2">video_label</v-icon>&nbsp;&nbsp;&nbsp;&nbsp;
                        <div>
                            <div class="headline">{{ analytics_list.day4uyesterday.ec_gout}}</div>
                            <div><hr /></div>
                        </div>
                    </v-card-title>
                    <v-card-actions>
                      <v-btn flat color="orange">Empty Container G/Out</v-btn>
                    </v-card-actions>
                </v-card>
              </v-flex>
            </v-layout>
        </v-container>
    </v-flex>
</template>

<script>
import sidemainmenu from '@/components/header.vue';
import bottomfootermenus from '@/components/footer.vue';
import axios from 'axios';
export default {
    name: 'analytics',
    data() {
        return {
            analytics_list: [],
            date_analytics: null,
            cfs_igm_pending: null
        }
    },
    components: {
        sidemainmenu
    },
    mounted:function(){
        this.getAnalytics()
    },
    computed: {
        today_gin_total() {
            return this.analytics_list.today.gate_in_20 + this.analytics_list.today.gate_in_40
        },
        yesterday_gin_total() {
            return this.analytics_list.yesterday.gate_in_20 + this.analytics_list.yesterday.gate_in_40
        },
        day4uyesterday_gin_total() {
            return this.analytics_list.day4uyesterday.gate_in_20 + this.analytics_list.day4uyesterday.gate_in_40
        }
    },
    methods: {
        getAnalytics: function () {
            this.API_URL = this.$hostname + "/reports/dashboard"
            axios.get(this.API_URL, { headers: {"Authorization" : 'jwt ' + localStorage.jwt} })
            .then((response) => {
                this.analytics_list = response.data;
            }, (error) => {
                this.errors = error.response.data.message;
            })
        },
        loadedstock() {
            this.$router.push('/loadedinventory')
        },
        gateinpending() {
            this.$router.push('/gateinpending')
        },
        gateins() {
            this.$router.push('/gateins')
        },
        fclgateout() {
            this.$router.push('/fclgateout')
        },
        destuffcargo() {
            this.$router.push('/destuffcargo')
        },
        ecgateout() {
            this.$router.push('/ecgateout')
        },
        igmpending() {
            this.$router.push('/igmpending')
        },
    }
    }
</script>